/**
 * Sets window.TELADOC_ENVELOP to an object carrying a member action
 * id (MAID). teladoc_envelop_tag_maid is the exact key telapp's
 * teladoc_envelop gem expects in the decoded header.
 */
import CommonUtils from '@/utils/common-utils';
import {MEMBER_ACTION_ID_SESSION} from '@/config';

type TeladocEnvelopPayload = {
    teladoc_envelop_tag_maid?: string;
};

function decodeEnvelop(encoded: string): TeladocEnvelopPayload {
    return JSON.parse(atob(encoded)) as TeladocEnvelopPayload;
}

// CommonUtils.getCookie's generated type declares getCookie(key: string), but the
// real signature is getCookie({key}) — see packages/ccm/.../common-utils.js.
const getCookie = CommonUtils.getCookie as unknown as (args: {
    key: string;
}) => string | null | undefined;

export default function teladocEnvelopHeaders(): string | undefined {
    if (window.TELADOC_ENVELOP) {
        try {
            const maid = decodeEnvelop(
                window.TELADOC_ENVELOP['Teladoc-Envelop']
            ).teladoc_envelop_tag_maid;

            if (maid) {
                return maid;
            }
        } catch {
            // Malformed envelope — clear it so a bad header isn't propagated, then rebuild below.
            delete window.TELADOC_ENVELOP;
        }
    }

    const cookie = getCookie({key: MEMBER_ACTION_ID_SESSION});
    const [maid] = cookie?.split('.') ?? [];

    if (!maid) {
        return undefined;
    }

    try {
        window.TELADOC_ENVELOP = {
            'Teladoc-Envelop': btoa(
                JSON.stringify({teladoc_envelop_tag_maid: maid})
            ),
        };
    } catch {
        delete window.TELADOC_ENVELOP;

        return undefined;
    }

    return maid;
}
